import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Smartphone, Check } from "lucide-react";
import { COMPANY } from "@/data/site";
import GooglePlayBadge from "@/components/GooglePlayBadge";

const FEATURES = [
  "Book battery & EV service in seconds",
  "Track your service requests & history",
  "Browse products and request quotes",
  "Get updates on offers & new arrivals",
];

export default function AppDownloadSection() {
  return (
    <section
      className="py-20 md:py-28 border-b border-white/10"
      data-testid="section-app-download"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="industrial-card p-8 md:p-14 relative overflow-hidden">
          <div
            className="absolute -bottom-24 -left-24 w-72 h-72 opacity-20 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #e63946 0%, transparent 70%)",
            }}
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="eyebrow flex items-center gap-2">
                <Smartphone size={14} className="text-[#e63946]" /> Mobile app
              </div>
              <h2 className="font-display text-3xl md:text-5xl uppercase mt-4 tracking-tighter leading-[0.95]">
                Book service on the go with the
                <span className="text-[#e63946]"> VPS app.</span>
              </h2>
              <p className="text-zinc-400 mt-5 max-w-xl text-sm md:text-base leading-relaxed">
                Manage battery & EV service requests, browse our catalogue and
                stay updated — all from your phone.
              </p>
              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-xl">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-zinc-300">
                    <Check size={14} className="text-[#e63946] mt-1 flex-shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <GooglePlayBadge testId="app-section-google-play" />
              </div>
            </div>

            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <div className="text-center" data-testid="app-qr-block">
                <div className="bg-white p-4 inline-block">
                  <QRCodeSVG
                    value={COMPANY.playStore}
                    size={168}
                    level="M"
                    fgColor="#0a0a0c"
                    bgColor="#ffffff"
                  />
                </div>
                <div className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">
                  Scan to install
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
